export default __webpack_public_path__ + "static/media/0186.fa317f4d.jpg";